/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { GalleryArtwork } from '../components/GalleryArtWork';
import { AuthContext, HARDHAT_NETWORK_NAME, HARDHAT_NETWORK_ID } from '../providers/AuthProvider';
import { NftContext } from '../providers/NftProvider';
import { ConnectWallet } from './ConnectWallet';
//import { NoWalletDetected } from './NoWalletDetected';
import { networkList } from '../config/networks';

import { useHistory } from 'react-router';
import { ToastAlert } from '../components/ToastAlert';

const Profile = () => {
  const authCtxt = useContext(AuthContext);
  const nftInfos = useContext(NftContext);
  const [userAddress, setUserAddress] = useState(null);
  const [userArtWorks, setUserArtWorks] = useState([]);
  const networkData = networkList.networks[0][parseInt(HARDHAT_NETWORK_ID,10)];

  const history = useHistory();
  //const [nfts, setNfts] = useState(nftInfos.nfts);


  useEffect(() => {
    setUserAddress(authCtxt.selectedAddress);
  }, [authCtxt.selectedAddress]);

  useEffect(() => {
    //setUserArtWorks(nftInfos.nfts.filter((nft) => (nft.authorAddress).toLowerCase() === authCtxt.selectedAddress));
    //console.log("nft length: " + nftInfos.nfts.length);
    setUserArtWorks(nftInfos.nfts);
    //console.log("userArtWorks.length: " + userArtWorks.length);
  }, [nftInfos.nfts, authCtxt.selectedAddress]);

  //if (!window.ethereum) {
  //  return <NoWalletDetected />;
  //}

  if (!userAddress || !window.ethereum) {
    return (
      <ConnectWallet
        connectWallet={() => authCtxt._connectWallet()}
        autoConnectWallet={() => authCtxt._autoConnectWallet()}
        networkName={HARDHAT_NETWORK_NAME}
        networkId={HARDHAT_NETWORK_ID}
        networkError={authCtxt.networkError}
        dismiss={() => authCtxt._dismissNetworkError()}
      />
    );
  }

    //setUserArtWorks(nftInfos.nfts);
    //console.log("[profile] nft length: " + nftInfos.nfts.length);
    //console.log("[profile] userArtWorks.length: " + userArtWorks.length);
    return (
    <div className="container fluid">
      <div className="row justify-content-center mt-5 pt-5 text-center">
        <h5 className="userAddress">
          {userAddress}
        </h5>
        <p>
          Network is <b>{networkData.networkName}</b> {networkData.testnet ? (<label className="link-danger"><b>[TestNet]</b></label>) : (<b>[Mainnet]</b>) }
        </p>
        {authCtxt.balance ? (
          <p>
            Balance: <b>{parseFloat(authCtxt.balance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {networkData.symbol}</b>
          </p>
        ) : (
          (networkData.testnet) ? (
            <p>
              You don't have any <b>{networkData.symbol}</b> on your wallet. You can use <a href={networkData.faucet} target="_blank" rel="noreferrer"><b>this faucet</b></a>.
            </p>
          ) : (
            <p>
            You don't have any <b>{networkData.symbol}</b> on your wallet, luckily you can <a href="https://ato.network/contact-us/" target="_blank" rel="noreferrer"><b>ask us here</b></a> or <a href="https://discord.gg/xw9dCeQ94Y" target="_blank" rel="noreferrer"><b>join our Discord</b></a>.
            </p>
          )
        )}
      </div>

      {userArtWorks.length ? (
        <div className="row">
          <h5 className="mb-2">Your artworks [{userArtWorks.length}]: </h5>
          {nftInfos.resultToast.display && <ToastAlert content={nftInfos.resultToast.content} />}
          {userArtWorks.map((artwork) => (
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 cards mt-4 " onClick={() => history.push(`/details?artwork=${artwork.address}`)} key={artwork.address}>
              <GalleryArtwork artwork={artwork}/>
            </div>
          ))}

        </div>
      ) : (
        <div className="row text-center">
          <p className="mb-4 fs-9">You haven't created any NFT with Āto yet.</p>

          {/* <h5 className="mb-2">You can create one here: </h5> btn btn-primary*/}

        </div>
      )}
      <div className="text-center">
          {userArtWorks.length ? (<div className="mt-4"><p></p></div>) : (<p></p>) }
          <NavLink to="/create" className="font-btn card border-light smallCard btn btn-primary" exact key="CreateBtn">
          {userArtWorks.length ? "New NFT" : "Create" }
          </NavLink>
      </div>

      <div className="footer"></div>

    </div>
  );
};


export default Profile;
